<app-avatar [user]="comment.user || comment.guest"></app-avatar>
<div class="comment-inner" [class.private]="comment.private" [class.resolved]="comment.resolved">
  <div class="comment-header">
    <div class="comment-header-info">
      <div class="author-name">
        <div>
          @if (comment.user) {
            {{ comment.user.first_name }} {{ comment.user.last_name }}
          } @else {
            {{ comment.guest.name }}
          }
        </div>
        @if (!thread()) {
          <div class="inline-time" [appTooltip]="comment.created_at * 1000 | date: 'short'">
            {{ comment.created_at * 1000 | relativeTime }}
          </div>
        }
      </div>
      @if (thread()) {
        <div class="comment-tags">
          <div class="time" [appTooltip]="comment.created_at * 1000 | date: 'short'">
            {{ comment.created_at * 1000 | relativeTime }}
          </div>
          @if (comment.annotation) {
            <div class="annotation">
              <app-svg size="-1" src="/assets/icons/annotate-brush.svg"></app-svg>
              <span>Drawing</span>
            </div>
          }
          @if (comment.position?.x && !comment.annotation) {
            <div class="position">
              <app-svg size="-1" src="/assets/icons/target.svg"></app-svg>
              <span>Position</span>
            </div>
          }
          @if (asset.type === 'video' && !(comment.position?.frame | isUndefinedOrNull)) {
            <div
              class="time"
              [appTooltip]="'Frame #' + (comment.position.frame | videoTimePercentToFrameCount: asset?.version_data)"
            >
              <app-svg size="-1" src="/assets/icons/clock-outline.svg"></app-svg>
              <span>{{ comment.position.frame | videoTimePercentToString: asset?.version_data }}</span>
            </div>
          }
        </div>
      }
    </div>
    <div class="comment-header-actions">
      @if (comment.authorId === myId || accessLevel === 'edit') {
        <app-context-menu [options]="{ width: '220px', noSpacing: true }" [position]="'right'" #menu>
          <button
            appButton
            name="comment-actions"
            location="comment-item"
            [iconButton]="true"
            [color]="comment.private ? 'simple-white-60' : 'simple'"
            shape="round"
            class="comment-actions-button"
            contextButton
            height="-1"
          >
            <app-svg src="/assets/icons/dots-vertical.svg"></app-svg>
          </button>
          <div contextContent class="comment-action-menu">
            @if (menu.isOpen) {
              <div class="button-menu">
                @if (comment.authorId === myId) {
                  <app-button-menu-item
                    name="edit-comment"
                    (onClick)="toggleEditing($event); menu.close()"
                    location="comment-item"
                    [fullWidth]="true"
                  >
                    @if (editing()) {
                      Cancel Edit
                    } @else {
                      {{ 'edit' | translate }}
                    }
                  </app-button-menu-item>
                  <div class="divider"></div>
                }
                @if (myId === comment.authorId || accessLevel === 'edit') {
                  <app-button-menu-item
                    name="delete-comment"
                    location="comment-item"
                    color="simple-warn"
                    (click)="deleteComment.emit(comment); menu.close()"
                    [fullWidth]="true"
                    >{{ 'delete' | translate }}
                  </app-button-menu-item>
                }
              </div>
            }
          </div>
        </app-context-menu>
      }

      @if (thread() && accessLevel !== 'view_only') {
        <button
          appButton
          name="resolve-comment-thread"
          location="comment-item"
          [iconButton]="true"
          [color]="comment.private ? (comment.resolved ? 'simple-orange' : 'simple-white-60') : 'simple'"
          height="0"
          shape="round"
          [class.disabled]="!enabledAndAllowedFeedbackOptions.includes('comment')"
          (click)="toggleResolved($event)"
          [appTooltip]="comment.resolved ? 'Unresolve' : 'Resolve'"
          [toolTipOrigin]="'top-right'"
        >
          @if (comment.resolved) {
            <app-svg src="/assets/icons/check-circle.svg"></app-svg>
          } @else {
            <app-svg src="/assets/icons/check-outline.svg"></app-svg>
          }
        </button>
      }
    </div>
  </div>

  @if (comment.text && !editing()) {
    <div class="comment-text" [innerHTML]="comment.text"></div>
  }
  @if (editing()) {
    <div class="editting" (click)="stopPropagation($event)">
      <div
        #editComment
        class="comment textarea"
        name="edit-comment"
        contenteditable
        [(wysiwyg)]="editingText"
        [allowHtml]="true"
      ></div>
      <div class="edit-comment-actions">
        <div (click)="cancelEditing($event)" class="comment-edit-action cancel">
          {{ 'cancel' | translate }}
        </div>
        <div (click)="saveEditing($event)" class="comment-edit-action save">{{ 'save' | translate }}</div>
      </div>
    </div>
  }

  @if (replies()?.length) {
    <div class="show-replies-toggle" [class.expand-replies]="expandReplies" (click)="toggleReplies($event)">
      <div>
        {{ replies().length }}
        @if (replies().length === 1) {
          Reply
        } @else {
          Replies
        }
      </div>
      <app-svg src="/assets/icons/12/chevron-down.svg" size="-2"></app-svg>
    </div>
  }
</div>
